import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Orcamentos1 from '../imagens/LancOrcamentos/Orcamentos1.png';
import Orcamentos2 from '../imagens/LancOrcamentos/Orcamentos2.png';
import Orcamentos3 from '../imagens/LancOrcamentos/Orcamentos3.png';
import Orcamentos4 from '../imagens/LancOrcamentos/Orcamentos4.png';
import Orcamentos5 from '../imagens/LancOrcamentos/Orcamentos5.png';
import Orcamentos6 from '../imagens/LancOrcamentos/Orcamentos6.png';
import Orcamentos7 from '../imagens/LancOrcamentos/Orcamentos7.png';
import Orcamentos8 from '../imagens/LancOrcamentos/Orcamentos8.png';
import Orcamentos9 from '../imagens/LancOrcamentos/Orcamentos9.png';
import Orcamentos10 from '../imagens/LancOrcamentos/Orcamentos10.png';

export default class LancOrcamentos extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o Lançamento de Orçamentos"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o lançamento de Orçamentos:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={Orcamentos1} alt="Orçamentos 1"/>
                        </div>

                        <div className="gray_bar"></div>

                        <div className="image-wrapper">
                            <img src={Orcamentos2} alt="Orçamentos 2"/>
                        </div>                        

                        <h3>No relatório de Orçamentos nós temos:</h3>
                        <ol>
                            <li>Botão para criar um novo orçamento.</li>
                            <li>Botão para abrir as opções de filtro avançadas e filtro básico usando número do orçamento.</li>
                            <li>Botão para imprimir todos os registros dentro da tabela principal da tela.</li>
                            <li>Tabela mostrando todos os orçamentos encontrados.</li>
                            <li>Informações de quantidade e valor total dos orçamentos encontrados.</li>
                            <li>Opções de situação do orçamento.</li>
                            <li>Botões auxiliares para alterar/excluir/importar um orçamento.</li>
                            <li>Paginação da tabela exibindo os orçamentos.</li>
                        </ol>

                        <div className="gray_bar"></div>

                        <h3>Como cadastrar um novo Orçamento</h3>

                        <p>
                            Para cadastrar um novo orçamento primeiramente clique no botão "Adicionar".
                        </p>  
                        <div className="image-wrapper">
                            <img src={Orcamentos3} alt="Orçamentos 3"/>
                        </div>      
                        <p>
                            O cadastro possui três abas, onde a primeira aba serve para colocar os dados principais do orçamento.
                        </p>  
                        <div className="image-wrapper">
                            <img src={Orcamentos4} alt="Orçamentos 4"/>
                        </div>                                                                                          
                        <p>
                            A segunda aba serve para adicionar produtos/serviços/avulços ao orçamento para definir o valor do orçamento. 
                        </p>
                        <div className="image-wrapper">
                            <img src={Orcamentos5} alt="Orçamentos 5"/>
                        </div>                      
                        <p>
                            Dentro da inclusão você pode escolher entre adicionar um produto, ou um serviço, ou um valor avulso caso não seja um produto ou serviço.
                        </p>       
                        <div className="image-wrapper">
                            <img src={Orcamentos6} alt="Orçamentos 6"/>
                        </div>    
                        <p>
                            A terceira aba serve para definir os check lists que se aplicam ao orçamento ou não. Caso o clecklist estiver conforme, basta clicar no botão de 
                            confirmação azul, caso não estiver conforme, clice no botão de não confirmado vermelho, e caso o checklist não se aplique ao orçamento atual, 
                            basta clicar no botão de de não se aplica com o X.
                        </p>  
                        <div className="image-wrapper">
                            <img src={Orcamentos7} alt="Orçamentos 7"/>
                        </div>   

                        <div className="gray_bar"></div>

                        <h3>Como excluir/Alterar um orçamento</h3>     

                        <p>
                            Para excluir ou alterar um orçamento você pode utilizar os botões auxiliares que estão na tabela de orçamentos.
                        </p>                  
                        <div className="image-wrapper">
                            <img src={Orcamentos8} alt="Orçamentos 8"/>
                        </div>  

                        <p>
                            A caixa de opções abaixo da coluna "Situação" serve para alterar a situação do orçamento.
                        </p> 
                        <div className="image-wrapper">
                            <img src={Orcamentos9} alt="Orçamentos 9"/>
                        </div> 
                        <p>
                            Os botões da última coluna servem para alterar um orçamento, excluir um orçamento, imprimir um orçamento, e gerar uma ordem de serviço a partir
                            do orçamento selecionado. 
                        </p>     
                        <div className="image-wrapper">
                            <img src={Orcamentos10} alt="Orçamentos 10"/>
                        </div>                         

                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancOrcamentos.js